import { SERVICE_USER_ERRORS } from '@mirai/services';

import { L10N } from '../BookingQuery.l10n.js';

export const getErrorText = (error) =>
  (error === SERVICE_USER_ERRORS.AUTHENTICATION
    ? L10N.NOTIFICATION_ERROR_AUTHENTICATION
    : L10N.NOTIFICATION_ERROR_NETWORK) || error?.message;
